import { memo, useCallback } from 'react';
import { Button, ButtonGroup, Tooltip, TooltipBody } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';
import { hasPermission, PERMISSIONS } from '~/roles';

import type { ROLE_NAMES } from '~/roles';
import type { Nullable } from '~/types/generics';

type PropsType = {
  clanId: number;
  roleName: Nullable<ROLE_NAMES>;
  selectedMembersLength: number;
  isDisabled: boolean;

  onRemoveMembersClick: () => void;
  onChangeCommanderClick: () => void;
  onChangeRoleClick: (memberToChangeId?: number) => void;
};

const tooltip = (text: string) => (
  <Tooltip>
    <TooltipBody>{text}</TooltipBody>
  </Tooltip>
);

const MembersControlBlock = ({
  clanId,
  roleName,
  selectedMembersLength,
  isDisabled,
  onRemoveMembersClick,
  onChangeCommanderClick,
  onChangeRoleClick,
}: PropsType) => {
  const canChangeRole = hasPermission(roleName, PERMISSIONS.CHANGE_ROLE);
  const canChangeCommander = hasPermission(roleName, PERMISSIONS.CHANGE_COMMANDER);
  const canRemoveMember = hasPermission(roleName, PERMISSIONS.REMOVE_MEMBER);

  const disabledMany = selectedMembersLength < 1 || isDisabled;

  const handleRemoveMembersClick = useCallback(() => {
    onRemoveMembersClick();
  }, [onRemoveMembersClick]);

  return (
    <ButtonGroup>
      {canChangeRole && (
        <Button
          key={`member-control-change-role-${clanId}`}
          isJustified
          isFlat
          isDisabled={disabledMany}
          onClick={() => onChangeRoleClick()}
          tooltipContent={
            !isDisabled && selectedMembersLength < 1 ? tooltip(t('Выберите одного или нескольких игроков')) : null
          }
        >
          {t('Изменить должность')}
        </Button>
      )}

      {canChangeCommander && (
        <Button
          key={`member-control-change-commander-${clanId}`}
          isJustified
          isFlat
          isDisabled={selectedMembersLength !== 1 || isDisabled}
          onClick={() => onChangeCommanderClick()}
          tooltipContent={
            !isDisabled && selectedMembersLength !== 1
              ? tooltip(t('Выберите одного игрока для передачи управления кланом'))
              : null
          }
        >
          {t('Передать управление')}
        </Button>
      )}

      {canRemoveMember && (
        <Button
          key={`member-control-remove-member-${clanId}`}
          isJustified
          isFlat
          isDisabled={disabledMany}
          onClick={() => handleRemoveMembersClick()}
          tooltipContent={
            !isDisabled && selectedMembersLength < 1 ? tooltip(t('Выберите одного или нескольких игроков')) : null
          }
        >
          {t('Исключить')}
        </Button>
      )}
    </ButtonGroup>
  );
};

export default memo(MembersControlBlock);
